import PropTypes from 'prop-types';

// mui
import { makeStyles } from '@material-ui/core';

import { Form } from 'components';

import * as utils from 'utils';

// app
import styles from './EditRiskQuote.styles';

export const EditRiskQuoteView = ({ fields, actions }) => {
  const classes = makeStyles(styles, { name: 'EditRiskQuote' })();

  return (
    <div className={classes.root}>
      <div>
        <Form
          id="edit-risk-quote"
          type="dialog"
          fields={fields}
          actions={actions}
          validationSchema={utils.form.getValidationSchema(fields)}
          defaultValues={utils.form.getInitialValues(fields)}
        />
      </div>
    </div>
  );
};

EditRiskQuoteView.propTypes = {
  fields: PropTypes.array.isRequired,
  actions: PropTypes.array.isRequired,
};
